import { createTheme } from '@mui/material/styles';

import themeConfig from '@config/theme.config';
import breakpoints from '@theme/breakpoints';
import components from '@theme/components';
import palette from '@theme/palette';
import typography from '@theme/typography';

const theme = createTheme({
  breakpoints,
  palette,
  typography,
  spacing: 8,
  shape: {
    borderRadius: themeConfig.borderRadius,
  },
  components,
});

export default theme;
